import appSelectors from 'selectors/app';
import showWidget from 'actions/ui/showWidget';
import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';
import uiSelectors from 'selectors/ui';

export default function showSelfService() {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(uiEvents.updateStage(uiEnums.STAGES.SELF_SERVICE));
    if (uiSelectors.getIsAutoShow(state.ui)) {
      dispatch(showWidget());
    }
    if (appSelectors.isClientReady(state.app) && uiSelectors.getCurrentLocation(state.ui) !== uiEnums.LOCATIONS.CHAT) {
      dispatch(uiEvents.navigateForward(uiEnums.LOCATIONS.CHAT));
    }
  };
}
